<template>
  <v-container fluid>
    <v-card v-show="!editPage && !confirmPage" flat>
      <v-card-title class="mb-3 text-h5 font-weight-bold">{{
        wordList.lbl_stock_collect_list
      }}</v-card-title>
      <v-card-text>
        <v-card flat>
          <div
            v-if="isXs"
            class="d-flex justify-end br_b_1 br_t_1 py-2 mb-5"
          >
            <v-btn variant="text" color="black" class="px-1" @click="onClickListSearch">
              絞り込み検索<v-icon>mdi-text-search</v-icon>
            </v-btn>
            <v-btn variant="text" color="black" class="pl-3 pr-0" @click="onClickListSetting">
              設定<v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
            <v-menu open-on-hover location="bottom">
              <template #activator="{ props }">
                <v-btn variant="text" color="black" v-bind="props" class="pl-3 pr-0">
                  アクション
                  <v-icon>mdi-cog</v-icon>
                </v-btn>
              </template>
              <v-list width="250" class="pl-5">
                <v-list-item-title
                  class="mb-3"
                  style="cursor: pointer"
                  @click="onClickDownload"
                >
                  <v-icon class="mr-2 mb-1">mdi-cloud-download</v-icon
                  >CSVダウンロード
                </v-list-item-title>
                <v-list-item-title
                  style="cursor: pointer"
                  @click="onClickCheckDelete"
                >
                  <v-icon class="mr-2">mdi-delete</v-icon>一括削除
                </v-list-item-title>
              </v-list>
            </v-menu>
          </div>
          <!-- 検索条件入力 { -->
          <v-expansion-panels v-else v-model="panel" flat multiple class="br_1">
            <v-expansion-panel>
              <v-expansion-panel-title
                class="py-0 font-weight-bold bk_gray_3"
                >{{ wordList.lbl_search }}</v-expansion-panel-title
              >
              <v-expansion-panel-text class="bk_gray_3">
                <v-divider/>
                <Form>
                  <v-card class="bk_gray_3" flat>
                    <v-card-text class="pt-9">
                      <v-row>
                        <!-- チェーンコード -->
                        <v-col
                          v-if="chainViewFlag"
                          cols="12"
                          sm="6"
                          md="4"
                          class="py-0"
                        >
                          <Field
                            v-slot="{ errors }"
                            name="chainName"
                            rules="max:100"
                          >
                            <div class="div-autocomplete-wrapper">
                              <div class="autocomplete-wrapper">
                                <v-autocomplete
                                  v-model="chainSelectValues"
                                  density="compact"
                                  :items="chainListItems"
                                  item-title="name"
                                  item-value="chain_code"
                                  :label="wordList.lbl_chain_name"
                                  :placeholder="wordList.plc_selectbox"
                                  :no-data-text="wordList.lbl_no_data_text"
                                  bg-color="white"
                                  :error-messages="errors"
                                  multiple
                                  return-object
                                  variant="outlined"
                                  @update:model-value="onChangeChain"
                                ></v-autocomplete>
                              </div>
                              <div class="select-all-wrapper">
                                <label
                                  class="select-all-checkbox-label"
                                  @click="onchangeChainAllCheck"
                                >
                                  <span class="select-all-checkmark">
                                    <div v-show="chainAllCheckFlag === 'some'">
                                      <i class="fas fa-minus" />
                                    </div>
                                    <div v-show="chainAllCheckFlag === 'all'">
                                      <i class="fas fa-check" />
                                    </div>
                                    <div v-show="chainAllCheckFlag === 'none'">
                                      <i
                                        class="fas"
                                        style="margin-right: 1px"
                                      />
                                    </div>
                                  </span>
                                  <span class="select-all-text">全選択</span>
                                </label>
                              </div>
                            </div>
                          </Field>
                        </v-col>
                        <!-- 配達元 -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                          <Field
                            v-slot="{ errors }"
                            name="deliverySource"
                            rules="required"
                          >
                            <div class="div-autocomplete-wrapper">
                              <div class="autocomplete-wrapper">
                                <v-autocomplete
                                  v-model="shopSelectValuesFrom"
                                  density="compact"
                                  :items="shopListItems"
                                  item-title="name"
                                  item-value="shop_code"
                                  bg-color="#fff"
                                  :label="wordList.lbl_delivery_source"
                                  :placeholder="wordList.lbl_delivery_source"
                                  :no-data-text="wordList.lbl_no_data_text"
                                  :error-messages="errors"
                                  multiple
                                  return-object
                                  variant="outlined"
                                  :disabled="shopDisabledFlag"
                                  @update:model-value="onChangeShop(0)"
                                ></v-autocomplete>
                              </div>
                              <div class="select-all-wrapper">
                                <label
                                  class="select-all-checkbox-label"
                                  @click="onChangeShopAllCheck(0)"
                                >
                                  <span class="select-all-checkmark">
                                    <div
                                      v-show="shopFromAllCheckFlag === 'some'"
                                    >
                                      <i class="fas fa-minus" />
                                    </div>
                                    <div
                                      v-show="shopFromAllCheckFlag === 'all'"
                                    >
                                      <i class="fas fa-check" />
                                    </div>
                                    <div
                                      v-show="shopFromAllCheckFlag === 'none'"
                                    >
                                      <i
                                        class="fas"
                                        style="margin-right: 1px"
                                      />
                                    </div>
                                  </span>
                                  <span class="select-all-text">全選択</span>
                                </label>
                              </div>
                            </div>
                          </Field>
                        </v-col>
                        <!-- 配達先 -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                          <div class="div-autocomplete-wrapper">
                            <div class="autocomplete-wrapper">
                              <v-autocomplete
                                v-model="shopSelectValuesTo"
                                density="compact"
                                :items="shopListItems"
                                item-title="name"
                                item-value="shop_code"
                                bg-color="#fff"
                                :label="wordList.lbl_delivery_destination"
                                :placeholder="wordList.lbl_delivery_destination"
                                :no-data-text="wordList.lbl_no_data_text"
                                multiple
                                return-object
                                variant="outlined"
                                :disabled="shopDisabledFlag"
                                @update:model-value="onChangeShop(1)"
                              ></v-autocomplete>
                            </div>
                            <div class="select-all-wrapper">
                              <label
                                class="select-all-checkbox-label"
                                @click="onChangeShopAllCheck(1)"
                              >
                                <span class="select-all-checkmark">
                                  <div v-show="shopToAllCheckFlag === 'some'">
                                    <i class="fas fa-minus" />
                                  </div>
                                  <div v-show="shopToAllCheckFlag === 'all'">
                                    <i class="fas fa-check" />
                                  </div>
                                  <div v-show="shopToAllCheckFlag === 'none'">
                                    <i class="fas" style="margin-right: 1px" />
                                  </div>
                                </span>
                                <span class="select-all-text">全選択</span>
                              </label>
                            </div>
                          </div>
                        </v-col>
                        <!-- 配達タイプ -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                          <Field
                            v-slot="{ errors }"
                            name="deliveryType"
                            rules="max:100"
                          >
                            <v-autocomplete
                              v-model="deliveryTypeValues"
                              density="compact"
                              :items="deliveryTypeItems"
                              item-title="label"
                              item-value="value"
                              :label="wordList.lbl_delivery_type"
                              :placeholder="wordList.plc_selectbox"
                              :no-data-text="wordList.lbl_no_data_text"
                              :error-messages="errors"
                              return-object
                              variant="outlined"
                              bg-color="#fff"
                            ></v-autocomplete>
                          </Field>
                        </v-col>
                        <!-- 受付番号 -->
                        <v-col cols="12" sm="6" md="4" class="py-0">
                          <Field
                            v-slot="{ errors, handleChange, handleBlur }"
                            name="receptionNumber"
                            :label="wordList.lbl_reception_number"
                            rules="numeric|max:8"
                          >
                            <v-text-field
                              v-model="searchConditionReceptionNo"
                              :label="wordList.lbl_reception_number"
                              bg-color="#fff"
                              density="compact"
                              variant="outlined"
                              clearable
                              :error-messages="errors"
                              @blur="handleBlur"
                              @update:model-value="handleChange"
                            ></v-text-field>
                          </Field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <!--
                        <v-col cols="3" class="mr-15 py-0">
                          <Field
                            v-slot="{ errors }"
                            name="レジNo"
                            rules="numeric|max:11"
                          >
                            <my-number-field
                              v-model="searchConditionRegisterNo"
                              label="レジNo"
                              dense="true"
                              outlined="true"
                              clearable="true"
                              :error-messages="errors"
                            ></my-number-field>
                          </Field>
                        </v-col>
                        <v-col cols="3" class="mr-15 py-0">
                          <Field
                            v-slot="{ errors }"
                            name="レシートNo"
                            rules="numeric|max:11"
                          >
                            <v-text-field
                              v-model="searchConditionReceiptNo"
                              label="レシートNo"
                              dense
                              outlined
                              clearable
                              :error-messages="errors"
                            ></v-text-field>
                          </Field>
                        </v-col>
                      -->
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" class="py-0 pr-0">
                          <v-menu
                            v-model="ReceptionDateFrom"
                            :close-on-content-click="false"
                            :offset="[0, -40]"
                            transition="scale-transition"
                            location="bottom start"
                          >
                            <template #activator="{ props }">
                              <Field
                                v-slot="{ errors }"
                                name="recriptDateFrom"
                                rules="max:100"
                              >
                                <v-text-field
                                  :model-value="searchConditionReceptionDateFromDisplay"
                                  :label="wordList.lbl_recript_date_from"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  variant="outlined"
                                  density="compact"
                                  clearable
                                  v-bind="props"
                                  :error-messages="errors"
                                  bg-color="#fff"
                                  @click:clear="clearReceptionDateFrom"
                                ></v-text-field>
                              </Field>
                            </template>
                            <v-locale-provider
                              locale="ja"
                              :messages="{ ja: vuetifyJa }"
                            >
                              <v-date-picker
                                v-datepicker-scroll
                                v-model="searchConditionReceptionDateFrom"
                                hide-header
                                show-adjacent-months
                                view-mode="month"
                                @update:model-value="onReceptionDateFromSelected"
                              ></v-date-picker>
                            </v-locale-provider>
                          </v-menu>
                        </v-col>
                        <p class="mt-3 mx-2">〜</p>
                        <v-col cols="12" sm="4" class="py-0 pr-0">
                          <v-menu
                            v-model="ReceptionDateTo"
                            :close-on-content-click="false"
                            :offset="[0, -40]"
                            transition="scale-transition"
                            location="bottom start"
                          >
                            <template #activator="{ props }">
                              <Field
                                v-slot="{ errors }"
                                name="recriptDateTo"
                                rules="max:100"
                              >
                                <v-text-field
                                  :model-value="searchConditionReceptionDateToDisplay"
                                  :label="wordList.lbl_recript_date_to"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  variant="outlined"
                                  density="compact"
                                  clearable
                                  v-bind="props"
                                  :error-messages="errors"
                                  bg-color="#fff"
                                  @click:clear="clearReceptionDateTo"
                                ></v-text-field>
                              </Field>
                            </template>
                            <v-locale-provider
                              locale="ja"
                              :messages="{ ja: vuetifyJa }"
                            >
                              <v-date-picker
                                v-datepicker-scroll
                                v-model="searchConditionReceptionDateTo"
                                hide-header
                                show-adjacent-months
                                view-mode="month"
                                @update:model-value="onReceptionDateToSelected"
                              ></v-date-picker>
                            </v-locale-provider>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" class="py-0 pr-0">
                          <v-menu
                            v-model="DeliveryDateFrom"
                            :close-on-content-click="false"
                            :offset="[0, -40]"
                            transition="scale-transition"
                            location="bottom start"
                          >
                            <template #activator="{ props }">
                              <Field
                                v-slot="{ errors }"
                                name="deliveryDateFrom"
                                rules="max:100"
                              >
                                <v-text-field
                                  :model-value="searchConditionDeliveryDateFromDisplay"
                                  :label="wordList.lbl_delivery_date_from"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  variant="outlined"
                                  density="compact"
                                  clearable
                                  v-bind="props"
                                  :error-messages="errors"
                                  bg-color="#fff"
                                  @click:clear="clearDeliveryDateFrom"
                                ></v-text-field>
                              </Field>
                            </template>
                            <v-locale-provider
                              locale="ja"
                              :messages="{ ja: vuetifyJa }"
                            >
                              <v-date-picker
                                v-datepicker-scroll
                                v-model="searchConditionDeliveryDateFrom"
                                hide-header
                                show-adjacent-months
                                view-mode="month"
                                @update:model-value="onDeliveryDateFromSelected"
                              ></v-date-picker>
                            </v-locale-provider>
                          </v-menu>
                        </v-col>
                        <p class="mt-3 mx-2">〜</p>
                        <v-col cols="12" sm="4" class="py-0 pr-0">
                          <v-menu
                            v-model="DeliveryDateTo"
                            :close-on-content-click="false"
                            :offset="[0, -40]"
                            transition="scale-transition"
                            location="bottom start"
                          >
                            <template #activator="{ props }">
                              <Field
                                v-slot="{ errors }"
                                name="deliveryDateTo"
                                rules="max:100"
                              >
                                <v-text-field
                                  :model-value="searchConditionDeliveryDateToDisplay"
                                  :label="wordList.lbl_delivery_date_to"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  variant="outlined"
                                  density="compact"
                                  clearable
                                  v-bind="props"
                                  :error-messages="errors"
                                  bg-color="#fff"
                                  @click:clear="clearDeliveryDateTo"
                                ></v-text-field>
                              </Field>
                            </template>
                            <v-locale-provider
                              locale="ja"
                              :messages="{ ja: vuetifyJa }"
                            >
                              <v-date-picker
                                v-datepicker-scroll
                                v-model="searchConditionDeliveryDateTo"
                                hide-header
                                show-adjacent-months
                                view-mode="month"
                                @update:model-value="onDeliveryDateToSelected"
                              ></v-date-picker>
                            </v-locale-provider>
                          </v-menu>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-row>
                        <v-col class="py-0">
                          <v-card class="bk_gray_3" flat>
                            <v-card-title class="px-0 py-0 text-subtitle-2">
                              {{ wordList.lbl_status }}
                            </v-card-title>
                            <v-card-text class="px-0 py-0">
                              <v-row>
                                <div
                                  v-for="item in deliveryStatusName"
                                  :key="item.id"
                                  class="pr-3 pl-2 d-flex"
                                >
                                  <v-checkbox
                                    v-model="statusSelectedItem"
                                    :value="item.id"
                                    :label="item.name"
                                  ></v-checkbox>
                                </div>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        variant="flat"
                        color="primary"
                        class="btn_width_1 my-2 mx-2"
                        @click="onClickSearch(false)"
                        ><v-icon>mdi-magnify</v-icon
                        >{{ wordList.lbl_search }}</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </Form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- 検索条件入力 } -->
          <!-- 一覧表示  { -->
          <v-card flat width="100%">
            <v-data-table-server
              v-model:items-per-page="listOptions.itemsPerPage"
              v-model:options="listOptions"
              v-model="selectListCheckbox"
              :items="listDataArray"
              :items-length="listDataTotalCount"
              :loading="listLoading"
              :headers="filteredTableHeaders"
              :no-data-text="wordList.lbl_no_data_text"
              item-value="receptionNo"
              show-select
              hide-default-footer
              return-object
              :mobile="isXs"
              :hide-default-header="isXs"
            >
              <template #top>
                <div class="d-flex justify-space-between mt-9 mb-5">
                  <div class="d-flex align-center flex-wrap">
                    <span class="pl-3">全 {{ listDataTotalCount }} 件 </span>
                    <span class="pl-1"> {{ displayPagingRange }} </span>
                    <v-pagination
                      v-model="listOptions.page"
                      :length="pageCount"
                      :total-visible="7"
                      variant="elevated"
                      density="comfortable"
                    ></v-pagination>
                  </div>
                  <div v-if="!isXs">
                    <v-btn
                      variant="text"
                      color="black"
                      class="px-2"
                      @click="onClickListSetting"
                    >
                      設定<v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                    <v-menu open-on-hover location="bottom">
                      <template #activator="{ props }">
                        <v-btn variant="text" color="black" v-bind="props" class="pr-0 pl-2">
                          アクション
                          <v-icon>mdi-cog</v-icon>
                        </v-btn>
                      </template>
                      <v-list width="250" class="pl-5">
                        <v-list-item-title
                          class="mb-3"
                          style="cursor: pointer"
                          @click="onClickDownload"
                        >
                          <v-icon class="mr-2 mb-1">mdi-cloud-download</v-icon
                          >CSVダウンロード
                        </v-list-item-title>
                        <v-list-item-title
                          style="cursor: pointer"
                          @click="onClickCheckDelete"
                        >
                          <v-icon class="mr-2">mdi-delete</v-icon>一括削除
                        </v-list-item-title>
                      </v-list>
                    </v-menu>
                  </div>
                </div>
              </template>
              <!-- モバイル時のみ全選択チェックボックスを表示（hide-default-headerでデフォルトヘッダーを非表示にしているため） -->
              <template #thead="{ selectAll, allSelected, someSelected }">
                <tr v-if="isXs">
                  <th>
                    <v-checkbox-btn
                        :model-value="allSelected"
                        :indeterminate="someSelected && !allSelected"
                        @update:model-value="selectAll"
                    />
                  </th>
                </tr>
              </template>
              <template
                #[`item.data-table-select`]="{ item, internalItem, isSelected, toggleSelect }"
              >
                <v-checkbox-btn
                  v-if="item.cancelAllowed"
                  :model-value="item.cancelAllowed ? isSelected(internalItem) : false"
                  @update:model-value="toggleSelect(internalItem)"
                >
                </v-checkbox-btn>
              </template>
              <template #[`item.actions`]="{ item }">
                <div v-if="!isXs">
                  <v-btn
                    :disabled="item.editAllowed === 0"
                    variant="outlined"
                    icon
                    color="primary"
                    class="my-2 ml-2"
                    size="x-small"
                    @click="onClickEdit(item.receptionNo, item.editAllowed)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    :disabled="item.cancelAllowed === false"
                    variant="outlined"
                    icon
                    color="red"
                    class="my-2 ml-2 mr-0"
                    size="x-small"
                    @click="onClickDelete(item.receptionNo)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
                <div v-else class="d-flex justify-end mb-3">
                  <v-btn
                    :disabled="item.editAllowed === 0"
                    variant="outlined"
                    color="primary"
                    class="my-2 mx-2"
                    @click="onClickEdit(item.receptionNo, item.editAllowed)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                    編集</v-btn
                  >
                  <v-btn
                    :disabled="item.cancelAllowed === false"
                    variant="outlined"
                    color="red"
                    class="my-2 ml-2 mr-0"
                    @click="onClickDelete(item.receptionNo)"
                  >
                    <v-icon>mdi-delete</v-icon>
                    削除</v-btn
                  >
                </div>
              </template>
            </v-data-table-server>
          </v-card>
        </v-card>
      </v-card-text>
    </v-card>
    <v-card v-if="editPage && !confirmPage" flat>
      <v-card-title class="mb-3 text-h5 font-weight-bold">
        {{ wordList.lbl_stock_collect_edt }}</v-card-title
      >
      <Form v-slot="{ meta }">
        <v-card-text>
          <v-card v-if="editDeliveryRequest !== null" flat>
            <v-card-text>
              <!-- 配達元 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_delivery_source }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col
                  cols="11"
                  sm="6"
                  md="6"
                  lg="6"
                  class="font-weight-black position-re"
                >
                  <v-card class="bk_gray_3" flat border>
                    <v-card-text>
                      <v-row dense>
                        <v-col class="font-weight-black">
                          <Field
                            v-slot="{ errors }"
                            name="deliverySource"
                            :label="wordList.lbl_delivery_source"
                            rules="required"
                            :model-value="shopSelectValues_from"
                          >
                            <v-autocomplete
                              v-model="shopSelectValues_from"
                              density="compact"
                              bg-color="#fff"
                              :items="shopListItems"
                              item-title="name"
                              item-value="shop_code"
                              :label="wordList.lbl_shop_name"
                              :placeholder="wordList.plc_selectbox"
                              :error-messages="errors"
                              :no-data-text="wordList.lbl_no_data_text"
                              return-object
                              variant="outlined"
                              :disabled="isDisabled"
                              @update:model-value="onChangeShopFrom"
                            ></v-autocomplete>
                          </Field>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col class="color_black">
                          {{ shopData_from_address }}
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <v-btn
                    v-if="!isDisabledChangeFromTo"
                    variant="text"
                    class="btn-Img position-ab change_btn_move_reg px-0"
                    color="#ffffff"
                    @click="onClickShopChangeBtn"
                  >
                    <img
                      class="mx-2"
                      src="@/assets/images/button/btn-change.png"
                    />
                  </v-btn>
                </v-col>
              </v-row>
              <!-- 配達先 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_delivery_destination }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col
                  cols="11"
                  sm="6"
                  md="6"
                  lg="6"
                  class="font-weight-black position-re"
                >
                  <v-card class="bk_gray_3" flat border>
                    <v-card-text>
                      <v-row dense>
                        <v-col class="font-weight-black">
                          <Field
                            v-slot="{ errors }"
                            name="deliveryDestination"
                            :label="wordList.lbl_delivery_destination"
                            rules="required"
                            :model-value="shopSelectValues_to"
                          >
                            <v-autocomplete
                              v-model="shopSelectValues_to"
                              density="compact"
                              bg-color="#fff"
                              :items="shopToListItems"
                              item-title="name"
                              item-value="shop_code"
                              :label="wordList.lbl_shop_name"
                              :placeholder="wordList.plc_selectbox"
                              :error-messages="errors"
                              :no-data-text="wordList.lbl_no_data_text"
                              return-object
                              variant="outlined"
                              :disabled="isDisabled"
                              @update:model-value="onChangeShopTo"
                            ></v-autocomplete>
                          </Field>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col class="color_black">
                          {{ shopData_to_address }}
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <!-- 配達希望エリア -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_delivery_area }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  sm="7"
                  md="7"
                  lg="7"
                  class="text-body-1 color_black"
                >
                  <v-row
                    v-if="
                      listDeliveryArea == null || listDeliveryArea.length <= 1
                    "
                    dense
                  >
                    <Field
                      name="area"
                      :label="wordList.lbl_delivery_area_name"
                      rules="required"
                      :model-value="deliveryAreaName"
                    >
                      <v-text-field
                        v-model="deliveryAreaName"
                        class="disabled-text-field"
                        density="compact"
                        variant="plain"
                        disabled
                      >
                      </v-text-field>
                    </Field>
                  </v-row>
                  <v-row
                    v-if="
                      listDeliveryArea !== null && listDeliveryArea.length > 1
                    "
                    dense
                  >
                    <v-btn
                      v-for="value in listDeliveryArea"
                      :key="value.area_code"
                      class="my-2 mx-2"
                      :class="{
                        btn_select_del_active:
                          value.area_code === editDeliveryRequest.area_code,
                      }"
                      color="primary"
                      variant="outlined"
                      min-width="200"
                      @click="onClickListDeliveryArea(value)"
                    >
                      {{ value.area_name }}
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 配達希望時間選択 -->
              <v-row dense :class="{ mb_5: isDisabled }">
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_delivery_time_select }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  sm="8"
                  md="8"
                  lg="8"
                  class="text-body-1 color_black"
                >
                  <Field
                    name="deliveryTimeSelect"
                    :label="wordList.lbl_delivery_time_select"
                    rules="required"
                    :model-value="display_delivery_time"
                  >
                    <v-text-field
                      v-model="display_delivery_time"
                      class="disabled-text-field"
                      density="compact"
                      variant="plain"
                      disabled
                    >
                    </v-text-field>
                  </Field>
                  <v-card
                    v-if="
                      disp_deliveryAvailabilityData.length > 0 && !isDisabled
                    "
                    class="mt-2 mb-8 px-3 py-3"
                    flat
                    border
                  >
                    <div id="wrap">
                      <div class="d-flex overflow-x-auto">
                        <div>
                          <div class="list_item_select_blank"></div>
                          <ul class="list_area br_b_1">
                            <li
                              v-for="[
                                delivery_id_desc,
                              ] in deliveryAvailabilityHeader"
                              :key="delivery_id_desc"
                              class="list_item_select_time"
                            >
                              {{ delivery_id_desc }}
                            </li>
                          </ul>
                        </div>
                        <div class="d-flex overflow-scrollr br_b_1">
                          <div
                            v-for="(
                              cols, deliverySelectDay
                            ) in disp_deliveryAvailabilityData"
                            :key="cols.delivery_data"
                          >
                            <ul
                              v-for="(delivery_data, deliverySelect) in cols"
                              :key="
                                delivery_data.delivery_date + delivery_data.key
                              "
                              class="list_area list_area_item"
                            >
                              <li
                                v-if="delivery_data.key == 1"
                                class="list_item_select list_item_day"
                              >
                                <div>
                                  <p class="mb-0">
                                    {{
                                      formatDate(delivery_data.delivery_date)
                                    }}
                                  </p>
                                </div>
                              </li>
                              <li class="list_item_select list_item_btn">
                                <a
                                  v-if="
                                    (delivery_data.availability !== '×' &&
                                      delivery_data.availability !== '0' &&
                                      delivery_data.availability !== '休') ||
                                    (delivery_data.already_requested === 1 &&
                                      editDeliveryRequest.delivery_id ==
                                        delivery_data.delivery_id &&
                                      editDeliveryRequest.required_delivery_date ==
                                        delivery_data.delivery_date)
                                  "
                                  class="btn_select_del"
                                  :class="{
                                    btn_select_del_active:
                                      editDeliveryRequest.delivery_id ==
                                        delivery_data.delivery_id &&
                                      editDeliveryRequest.required_delivery_date ==
                                        delivery_data.delivery_date,
                                  }"
                                  @click="
                                    onDeliveryAvailabilityClick(
                                      delivery_data.delivery_date,
                                      delivery_data.delivery_id,
                                      delivery_data.delivery_start_time,
                                      delivery_data.delivery_end_time,
                                      deliverySelectDay,
                                      deliverySelect
                                    )
                                  "
                                >
                                  <!--<i :class="getClass(delivery_data.availability)"></i>-->
                                  <i
                                    v-if="delivery_data.availability == '○'"
                                    class="circle_receive"
                                    :class="{
                                      circle_receive_active:
                                        deliverySelectDay ===
                                          deliverySelectDayBox &&
                                        deliverySelect === deliverySelectBox,
                                    }"
                                  ></i>
                                  <i
                                    v-else-if="
                                      delivery_data.availability == '△' ||
                                      delivery_data.availability == '▲'
                                    "
                                    class="triangle_receive"
                                    :class="{
                                      triangle_receive_active:
                                        deliverySelectDay ===
                                          deliverySelectDayBox &&
                                        deliverySelect === deliverySelectBox,
                                    }"
                                  ></i>
                                  <div
                                    v-else
                                    class="text_16px font-weight-bold color_primary"
                                  >
                                    {{ delivery_data.availability }}
                                  </div>
                                </a>
                                <div
                                  v-else-if="
                                    (delivery_data.availability === '×' ||
                                      delivery_data.availability === '0') &&
                                    !(
                                      editDeliveryRequest.delivery_id ==
                                        delivery_data.delivery_id &&
                                      editDeliveryRequest.required_delivery_date ==
                                        delivery_data.delivery_date
                                    )
                                  "
                                >
                                  <i class="batsu_receive"></i>
                                </div>
                                <div
                                  v-else-if="
                                    delivery_data.availability === '休' &&
                                    !(
                                      editDeliveryRequest.delivery_id ==
                                        delivery_data.delivery_id &&
                                      editDeliveryRequest.required_delivery_date ==
                                        delivery_data.delivery_date
                                    )
                                  "
                                  class="text_16px font-weight-bold color_primary"
                                >
                                  {{ delivery_data.availability }}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>
                  <p v-if="deliveryId_0_Flg" class="pt-0 mt-0">
                    ※配達開始時間
                    {{ deliveryStartTime }}～(当日配達)受付終了時間
                    {{ acceptableEndTime.substring(0, 5) }}まで
                  </p>
                </v-col>
              </v-row>
              <!-- 配達希望時間 -->
              <v-row v-if="deliveryId_0_Flg" dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_delivery_time }}
                  </v-row>
                </v-col>
                <v-col cols="12" sm="8" md="8" lg="8">
                  <div class="d-flex align-center delivery-time-row">
                    <div class="delivery-time-select">
                      <v-autocomplete
                        v-model="deliveryStartHourValues"
                        density="compact"
                        :items="deliveryStartHourItem"
                        item-title="deliveryStartHour"
                        item-value="deliveryStartHour"
                        :no-data-text="wordList.lbl_no_data_text"
                        bg-color="white"
                        return-object
                        variant="outlined"
                        @update:model-value="onChangeDeliveryStartHour"
                      ></v-autocomplete>
                    </div>
                    <span class="mx-1 text-body-1 text-black">時</span>
                    <div class="delivery-time-select">
                      <v-autocomplete
                        v-model="deliveryStartMinitValues"
                        density="compact"
                        :items="deliveryStartMinitItem"
                        item-title="label"
                        item-value="deliveryStartMinit"
                        :no-data-text="wordList.lbl_no_data_text"
                        bg-color="white"
                        return-object
                        variant="outlined"
                        @update:model-value="onChangeDeliveryStartMinit"
                      ></v-autocomplete>
                    </div>
                    <span class="mx-1 text-body-1 text-black">分から3時間以内</span>
                  </div>
                </v-col>
              </v-row>
              <!-- 決済方法 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_pay_method }}
                  </v-row>
                </v-col>
                <v-col cols="10" sm="4" md="4" lg="4">
                  <v-autocomplete
                    v-model="editDeliveryRequest.payment_method"
                    density="compact"
                    :items="paymentMethodItems"
                    :placeholder="wordList.plc_selectbox"
                    :no-data-text="wordList.lbl_no_data_text"
                    variant="outlined"
                    return-object
                    :disabled="isDisabled"
                    @update:model-value="
                      onChangePaymentMethod(editDeliveryRequest.payment_method)
                    "
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <!-- 支払金額 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center"
                    v-if="paymentRequiredFlg"
                    dense
                      class="form-label-row mr-3 justify-sm-end"
                  >
                    {{ wordList.lbl_pay_money }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                  <v-row align="center"
                    v-if="!paymentRequiredFlg"
                    dense
                      class="form-label-row mr-15 justify-sm-end"
                  >
                    {{ wordList.lbl_pay_money }}
                  </v-row>
                </v-col>
                <v-col cols="8" sm="2" md="2" lg="2">
                  <Field
                    v-if="paymentRequiredFlg"
                    v-slot="{ errors }"
                    name="payMoney"
                    rules="required|max:11"
                  >
                    <v-text-field
                      v-model="dummy_payment_amount"
                      class="text-right"
                      :placeholder="wordList.plc_pay_money"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @focus="onFocus(dummy_payment_amount)"
                      @blur="onBlur(dummy_payment_amount)"
                    >
                    </v-text-field>
                  </Field>
                  <Field
                    v-if="!paymentRequiredFlg"
                    v-slot="{ errors }"
                    name="payMoney"
                    rules="max:11"
                  >
                    <v-text-field
                      v-model="dummy_payment_amount"
                      class="text-right"
                      :placeholder="wordList.plc_pay_money"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @focus="onFocus(dummy_payment_amount)"
                      @blur="onBlur(dummy_payment_amount)"
                    >
                    </v-text-field>
                  </Field>
                </v-col>
                <span class="mt-3">{{ wordList.lbl_yen }}</span>
              </v-row>
              <!-- レジNo -->
              <!--
              <v-row dense>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15" justify="end">{{
                    wordList.lbl_cash_register_no
                  }}</v-row>
                </v-col>
                <v-col cols="2">
                  <Field
                    v-slot="{ errors }"
                    name="cashRegisterNo"
                    rules="numeric|max:4"
                  >
                    <v-text-field
                      dense
                      outlined
                      v-model="editDeliveryRequest.register_no"
                      :error-messages="errors"
                      :disabled="isDisabled"
                    >
                    </v-text-field>
                  </Field>
                </v-col>
              </v-row>
              -->
              <!-- レシートNo -->
              <!--
              <v-row dense>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15" justify="end">{{
                    wordList.lbl_receipt_no
                  }}</v-row>
                </v-col>
                <v-col cols="2">
                  <Field
                    v-slot="{ errors }"
                    name="receiptNo"
                    rules="numeric|max:4"
                  >
                    <v-text-field
                      dense
                      outlined
                      v-model="editDeliveryRequest.receipt_no"
                      :error-messages="errors"
                      :disabled="isDisabled"
                    >
                    </v-text-field>
                  </Field>
                </v-col>
              </v-row>
              -->
              <!-- 個口数 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_unit_number }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="8" sm="2" md="2" lg="2">
                  <Field
                    v-slot="{ errors }"
                    name="unitNumber"
                    :label="wordList.lbl_unit_number"
                    rules="required"
                    :model-value="editDeliveryRequest.unit"
                  >
                    <v-autocomplete
                      v-model="editDeliveryRequest.unit"
                      :items="unitItems"
                      density="compact"
                      variant="outlined"
                      return-object
                      :error-messages="errors"
                      :no-data-text="wordList.lbl_no_data_text"
                      :disabled="isDisabled"
                    ></v-autocomplete>
                  </Field>
                </v-col>
              </v-row>
              <!-- 配達備考 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_memo_delivery }}
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <Field
                    v-slot="{ errors }"
                    name="memoDelivery"
                    :label="wordList.lbl_memo_delivery"
                    rules="max:500"
                    :model-value="editDeliveryRequest.delivery_notes"
                  >
                    <v-textarea
                      v-model="editDeliveryRequest.delivery_notes"
                      :placeholder="wordList.plc_memo_delivery"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      :disabled="isDisabled"
                    >
                    </v-textarea>
                  </Field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="justify-center flex-wrap">
              <!-- キャンセルボタン -->
              <v-btn
                variant="flat"
                color="return"
                class="btn_width_1 my-2 mx-2"
                @click="onClickUpdateCancel"
              >
                <v-icon>mdi-arrow-left</v-icon>
                {{ wordList.btn_return }}
              </v-btn>
              <!-- 登録手続きへボタン -->
              <v-btn
                variant="flat"
                color="primary"
                class="btn_width_1 my-2 mx-2"
                :disabled="!meta.valid"
                @click="onClickUpdate"
                ><v-icon>mdi-playlist-edit</v-icon
                >{{ wordList.btn_regist_confirm }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-card-text>
      </Form>
    </v-card>
    <!-- 配達依頼更新確認 { -->
    <v-card v-if="confirmPage" flat>
      <v-card-title class="mb-3 text-h5 font-weight-bold">
        {{ wordList.lbl_stock_collect_confirm }}
      </v-card-title>
      <v-card-text class="confirm-display-text">
        <!-- ２件分配達となる場合のメッセージ -->
        <v-row v-if="isDoubleDeli" class="time_chk_card">
          <v-col cols="10" class="text-subtitle-1 text-red">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="doubleDeliCheckLabel"></span>
          </v-col>
        </v-row>
        <!-- チャーター便となる場合のメッセージ -->
        <v-row v-if="isCharterDeli" class="time_chk_card">
          <v-col cols="10" class="text-subtitle-1 text-red">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="charterDeliChkLabel"></span>
          </v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 配達元 -->
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_delivery_source }}
              <ImportantChip></ImportantChip> </v-row
          ></v-col>
          <v-col cols="12" sm="7" md="7" lg="7">
            {{ shopSelectValues_from.name }}
          </v-col>
        </v-row>
        <!-- 配達先 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_delivery_destination }}
              <ImportantChip></ImportantChip> </v-row
          ></v-col>
          <v-col cols="12" sm="7" md="7" lg="7">
            {{ shopSelectValues_to.name }}
          </v-col>
        </v-row>
        <!-- 配達希望エリア -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end"
              >{{ wordList.lbl_delivery_area }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="7" md="7" lg="7">
            {{ deliveryAreaName }}
          </v-col>
        </v-row>
        <!-- 配達希望時間選択 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_delivery_time_select }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="7" md="7" lg="7">
            {{ display_delivery_time }}
          </v-col>
        </v-row>
        <!-- 配達希望時間 -->
        <v-row v-if="deliveryId_0_Flg" dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_delivery_time }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="7" md="7" lg="7">
            {{ irregularDeliveryStartTime }} ～
            {{ irregularDeliveryEndTime }}
          </v-col>
        </v-row>
        <!-- 決済方法 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_pay_method }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="7" md="7" lg="7">{{
            chainPaymentMethodSelectValues.item
              ? chainPaymentMethodSelectValues.item
              : editDeliveryRequest.payment_method
          }}</v-col>
        </v-row>
        <v-row dense class="mb-3">
          <!-- 支払金額 -->
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center"
              v-if="paymentRequiredFlg"
              dense
                class="form-label-row mr-3 justify-sm-end"
            >
              {{ wordList.lbl_pay_money }}
              <ImportantChip></ImportantChip>
            </v-row>
            <v-row align="center" v-else dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_pay_money }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="7" md="7" lg="7">
            {{ dummy_payment_amount }}
            <span
              v-if="
                dummy_payment_amount !== null && dummy_payment_amount !== ''
              "
            >
              {{ wordList.lbl_yen }}
            </span>
          </v-col>
        </v-row>
        <!-- レジNo -->
        <!--
        <v-row dense class="mb-3">
          <v-col cols="4" class="font-weight-black"
            ><v-row align="center" dense class="form-label-row mr-15" justify="end">{{
              wordList.lbl_cash_register_no
            }}</v-row></v-col
          >
          <v-col cols="8">{{ editDeliveryRequest.register_no }}</v-col>
        </v-row>
        -->
        <!-- レシートNo -->
        <!--
        <v-row dense class="mb-3">
          <v-col cols="4" class="font-weight-black"
            ><v-row align="center" dense class="form-label-row mr-15" justify="end">{{
              wordList.lbl_receipt_no
            }}</v-row></v-col
          >
          <v-col cols="8">{{ editDeliveryRequest.receipt_no }}</v-col>
        </v-row>
        -->
        <!-- 個口数 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_unit_number }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col
            v-if="editDeliveryRequest.unit > 0"
            cols="12"
            sm="7"
            md="7"
            lg="7"
            >{{ editDeliveryRequest.unit }}{{ wordList.lbl_unit }}</v-col
          >
        </v-row>
        <v-row dense class="mb-3">
          <!-- 配達備考 -->
          <v-col cols="4" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">{{
              wordList.lbl_memo_delivery
            }}</v-row></v-col
          >
          <v-col cols="8" sm="7" md="7" lg="7">
            {{ editDeliveryRequest.delivery_notes }}
          </v-col>
          <v-col offset="4" cols="8" class="text-body-1 text-caption">
            {{ messageDeliveryNotes }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center flex-wrap">
        <v-btn
          variant="flat"
          color="return"
          class="btn_width_1 my-2 mx-2"
          @click="onClickConfirmUpdateCancel"
        >
          <v-icon>mdi-arrow-left</v-icon>
          {{ wordList.btn_return }}
        </v-btn>
        <v-btn
          v-if="processFlag > 0"
          variant="flat"
          color="primary"
          class="btn_width_1 my-2 mx-2"
          @click="onClickConfirmUpdateOk"
        >
          <v-icon>mdi-playlist-edit</v-icon>
          {{ wordList.btn_regist_complete }}
        </v-btn>
        <v-btn
          v-else
          variant="flat"
          color="primary"
          class="btn_width_1 my-2 mx-2"
          @click="onClickConfirmDeleteOk"
        >
          <v-icon>mdi-playlist-edit</v-icon>
          {{ wordList.btn_delete_complete }}
        </v-btn>
      </v-card-actions>
      <v-overlay
        :model-value="overlay"
        class="d-flex align-center justify-center"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
    <!-- } 配達依頼更新確認 -->
    <AlertDialog
      v-model="errdialog"
      :show-title="false"
      :message="errMessage"
      type="error"
    />
    <!-- 削除確認ダイアログ {-->
    <v-dialog
      v-model="confirmDeleteDialog"
      content-class="dialog_width_1"
      :lock-scroll="false"
      scrollable
    >
      <v-data-iterator
        :items="filteredSelectListCheckbox"
        item-key="receptionNo"
        hide-default-footer
        :items-per-page="-1"
      >
        <template #default="{ items }">
          <v-card class="rounded-t rounded-b-0">
            <v-card-title class="bg-red mb-5" style="color: white">
              一括削除内容確認
            </v-card-title>

            <v-card-text class="font-weight-black">
              {{ filteredSelectListCheckbox.length }} 件の配達依頼を削除します。
            </v-card-text>

            <v-card-text style="max-height: 60vh; overflow-y: auto;">
              <v-card
                v-for="item in items"
                :key="item.raw.receptionNo"
                :flat="true"
                variant="outlined"
                class="mb-5"
              >
                <v-card-title>
                  <h4>{{ item.raw.receptionNo }} : {{ item.raw.shipFromName }}</h4>
                </v-card-title>
                <v-divider class="mx-4"></v-divider>
                <v-list density="compact">
                  <v-list-item>
                    <v-row dense>
                      <v-col
                        cols="5"
                        sm="3"
                        md="3"
                        lg="3"
                        class="font-weight-black"
                      >
                        <v-row dense class="py-2 justify-end"
                          >{{ wordList.lbl_reception_number }}:</v-row
                        >
                      </v-col>
                      <v-col cols="7" class="d-flex align-center"
                        >{{ item.raw.receptionNo }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row dense>
                      <v-col
                        cols="5"
                        sm="3"
                        md="3"
                        lg="3"
                        class="font-weight-black"
                      >
                        <v-row dense class="py-2 justify-end"
                          >{{ wordList.lbl_delivery_source }}:</v-row
                        >
                      </v-col>
                      <v-col cols="7" class="d-flex align-center"
                        >{{ item.raw.shipFromName }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row dense>
                      <v-col
                        cols="5"
                        sm="3"
                        md="3"
                        lg="3"
                        class="font-weight-black"
                      >
                        <v-row dense class="py-2 justify-end"
                          >{{ wordList.lbl_delivery_destination }}:</v-row
                        >
                      </v-col>
                      <v-col cols="7" class="d-flex align-center"
                        >{{ item.raw.deliveryName }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row dense>
                      <v-col
                        cols="5"
                        sm="3"
                        md="3"
                        lg="3"
                        class="font-weight-black"
                      >
                        <v-row dense class="py-2 justify-end"
                          >{{ wordList.lbl_delivery_date }}:</v-row
                        >
                      </v-col>
                      <v-col cols="7" class="d-flex align-center"
                        >{{ item.raw.plannedDeliveryDate }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <v-list-item>
                    <v-row dense>
                      <v-col
                        cols="5"
                        sm="3"
                        md="3"
                        lg="3"
                        class="font-weight-black"
                      >
                        <v-row dense class="py-2 justify-end"
                          >{{ wordList.lbl_delivery_stools_info }}:</v-row
                        >
                      </v-col>
                      <v-col cols="7" class="d-flex align-center"
                        >{{ item.raw.deliveryIdName }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <!-- 配達予定日データをDSSと連携されるまで非表示にする
                    <v-list-item>
                      <v-row dense>
                        <v-col
                          cols="5"
                          sm="3"
                          md="3"
                          lg="3"
                          class="font-weight-black"
                        >
                          <v-row dense class="py-2 justify-end"
                            >{{ wordList.lbl_delivery_schedule }}:</v-row
                          >
                        </v-col>
                        <v-col cols="7" class="d-flex align-center"
                          >{{ item.deliveryEstimatedTime }}
                        </v-col>
                      </v-row>
                    </v-list-item>
                  -->
                  <v-list-item>
                    <v-row dense>
                      <v-col
                        cols="5"
                        sm="3"
                        md="3"
                        lg="3"
                        class="font-weight-black"
                      >
                        <v-row dense class="py-2 justify-end"
                          >{{ wordList.lbl_status }}:</v-row
                        >
                      </v-col>
                      <v-col cols="7" class="d-flex align-center"
                        >{{ item.raw.status }}
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-card-text>
            <!-- ボタンをカード内に配置して上下中央に表示（モバイル時はflex-wrapで折り返し） -->
            <v-card-actions class="justify-center pb-8 flex-wrap">
              <!-- 戻るボタン -->
              <v-btn
                variant="flat"
                color="return"
                class="px-16 mx-2 my-2"
                width="168px"
                @click="confirmDeleteDialog = false"
              >
                <v-icon>mdi-arrow-left</v-icon>
                {{ wordList.btn_return }}
              </v-btn>
              <v-btn
                variant="outlined"
                class="bg-red-darken-1 mx-2 my-2"
                color="white"
                width="168px"
                @click="onClickCheckDeleteComplete"
              >
                {{ wordList.btn_delete_all }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-data-iterator>
      <v-overlay
        :model-value="overlay"
        class="d-flex align-center justify-center"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>
    <!-- } 削除確認ダイアログ -->
    <!-- ダウンロード中 ダイアログ { -->
    <v-dialog v-model="downloadingDialog" persistent width="40%">
      <v-card>
        <v-card-title>在庫移動・回収依頼ダウンロード</v-card-title>
        <v-card-text>
          <v-container style="height: 200px">
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col class="text-subtitle-1 text-center" cols="12">
                ダウンロード中...
              </v-col>
              <v-col cols="6">
                <v-progress-linear
                  color="deep-purple-accent-4"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- } ダウンロード中 ダイアログ -->
    <!-- 一覧設定ダイアログ { -->
    <v-dialog
      v-model="displayListSettingDialog"
      persistent
      content-class="dialog_width_2"
      height="100%"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center pb-0">
          <div>一覧設定</div>
          <v-btn
            variant="text"
            icon="mdi-close"
            @click="displayListSettingDialog = false"
          ></v-btn>
        </v-card-title>
        <v-card-text class="py-0">
          <v-container class="pt-2">
            <draggable
              v-model="tableHeadersSetting"
              item-key="id"
            >
              <template #item="{ element: tableHeader }">
                <v-row
                  class="mt-0 mb-0 pt-0 pb-0"
                  :class="{ br_b_1: isXs }"
                >
                  <v-col
                    cols="12"
                    class="my-2 pt-0 pb-0 d-flex justify-space-between align-center"
                    :class="{ 'px-0': isXs }"
                  >
                    <div :class="{ caption: isXs }">
                      <v-icon>mdi-drag</v-icon>
                      {{ tableHeader.settingText }}
                    </div>
                    <div
                      class="d-flex pt-0"
                      :class="{ 'mt-1': isXs }"
                    >
                      <div class="d-flex align-center">
                        <v-switch
                          v-model="tableHeader.display"
                          color="primary"
                          class="mt-0"
                          hide-details
                        ></v-switch>
                        <div class="setting_line"></div>
                      </div>
                      <v-radio-group
                        v-model="tableHeader.order"
                        inline
                        class="mt-0 flex-shrink-0"
                        hide-details
                      >
                        <v-radio
                          true-icon="mdi-arrow-up-drop-circle"
                          false-icon="mdi-arrow-up-drop-circle-outline"
                          value="asc"
                          :disabled="tableHeader.orderDisabled"
                          class="mr-1"
                          false="color_primary"
                        ></v-radio>
                        <v-radio
                          true-icon="mdi-arrow-down-drop-circle"
                          false-icon="mdi-arrow-down-drop-circle-outline"
                          value="desc"
                          :disabled="tableHeader.orderDisabled"
                          class="mr-0"
                          false="color_primary"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </v-col>
                </v-row>
              </template>
            </draggable>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-5 pb-7">
          <v-btn
            class="width_30per"
            variant="outlined"
            @click="onClickListSettingCancel"
            >キャンセル</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="width_30per"
            variant="outlined"
            @click="onClickListSettingReset"
            >リセット</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            class="width_30per"
            variant="flat"
            color="primary"
            @click="onClickListSettingOk"
            >設定</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- } 一覧設定ダイアログ -->
    <!-- スマホ検索ダイアログ { -->
    <v-dialog
      v-model="displayListSearchDialog"
      fullscreen
      :scrim="false"
      transition="dialog-bottom-transition"
    >
      <Form v-slot="{ invalid }">
        <v-card flat>
          <v-card-title class="px-0 py-0">
            <v-toolbar color="primary" class="text-white">
              <v-btn
                icon
                class="text-white"
                @click="displayListSearchDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>絞り込み検索</v-toolbar-title>
              <v-spacer></v-spacer> </v-toolbar
          ></v-card-title>
          <v-card-text
            class="py-0 overflow-auto"
            style="height: calc(100vh - 133px)"
          >
            <v-row>
              <!-- 配達元 -->
              <v-col cols="12" sm="6" md="4" class="mt-10 py-0">
                <v-autocomplete
                  v-model="shopSelectValuesFrom"
                  density="compact"
                  :items="shopListItems"
                  item-title="name"
                  item-value="shop_code"
                  bg-color="#fff"
                  :label="wordList.lbl_delivery_source"
                  :placeholder="wordList.lbl_delivery_source"
                  :no-data-text="wordList.lbl_no_data_text"
                  multiple
                  return-object
                  variant="outlined"
                  :disabled="shopDisabledFlag"
                  @update:model-value="onChangeShop(0)"
                ></v-autocomplete>
              </v-col>
              <!-- 配達先 -->
              <v-col cols="12" sm="6" md="4" class="py-0">
                <v-autocomplete
                  v-model="shopSelectValuesTo"
                  density="compact"
                  :items="shopListItems"
                  item-title="name"
                  item-value="shop_code"
                  bg-color="#fff"
                  :label="wordList.lbl_delivery_destination"
                  :placeholder="wordList.lbl_delivery_destination"
                  :no-data-text="wordList.lbl_no_data_text"
                  multiple
                  return-object
                  variant="outlined"
                  :disabled="shopDisabledFlag"
                  @update:model-value="onChangeShop(1)"
                ></v-autocomplete>
              </v-col>
              <!-- 配達タイプ -->
              <v-col cols="12" sm="6" md="4" class="py-0">
                <Field
                  v-slot="{ errors }"
                  name="deliveryType"
                  rules="max:100"
                >
                  <v-autocomplete
                    v-model="deliveryTypeValues"
                    density="compact"
                    :items="deliveryTypeItems"
                    item-title="label"
                    item-value="value"
                    :label="wordList.lbl_delivery_type"
                    :placeholder="wordList.plc_selectbox"
                    :no-data-text="wordList.lbl_no_data_text"
                    :error-messages="errors"
                    return-object
                    variant="outlined"
                    bg-color="#fff"
                  ></v-autocomplete>
                </Field>
              </v-col>
              <!-- 受付番号 -->
              <v-col cols="12" sm="6" md="4" class="py-0 mt-9">
                <Field
                  v-slot="{ errors, handleChange, handleBlur }"
                  name="receptionNumber"
                  :label="wordList.lbl_reception_number"
                  rules="numeric|max:8"
                >
                  <v-text-field
                    v-model="searchConditionReceptionNo"
                    :label="wordList.lbl_reception_number"
                    bg-color="#fff"
                    density="compact"
                    variant="outlined"
                    clearable
                    :error-messages="errors"
                    @blur="handleBlur"
                    @update:model-value="handleChange"
                  ></v-text-field>
                </Field>
              </v-col>
            </v-row>
            <v-row class="mb-5">
              <v-col cols="12">
                <v-row>
                  <v-col cols="11" sm="4" class="py-0">
                    <Field
                      v-slot="{ errors }"
                      name="recriptDateFrom"
                      rules="max:100"
                    >
                      <v-menu
                        v-model="ReceptionDateFrom"
                        :close-on-content-click="false"
                        location="bottom start"
                        :offset="[0, -40]"
                        transition="scale-transition"
                      >
                        <template #activator="{ props }">
                          <v-text-field
                            v-bind="props"
                            :model-value="searchConditionReceptionDateFromDisplay"
                            :label="wordList.lbl_recript_date_from"
                            prepend-icon="mdi-calendar"
                            readonly
                            variant="outlined"
                            density="compact"
                            clearable
                            :error-messages="errors"
                            bg-color="#fff"
                            hide-details
                            @click:clear="clearReceptionDateFrom"
                          ></v-text-field>
                        </template>
                        <v-locale-provider
                          locale="ja"
                          :messages="{ ja: vuetifyJa }"
                        >
                          <v-date-picker
                            v-datepicker-scroll
                            v-model="searchConditionReceptionDateFrom"
                            hide-header
                            show-adjacent-months
                            view-mode="month"
                            @update:model-value="onReceptionDateFromSelected"
                          ></v-date-picker>
                        </v-locale-provider>
                      </v-menu>
                    </Field>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-center"
                    ><span>〜</span></v-col
                  >
                  <v-col cols="11" sm="4" class="py-0">
                    <Field
                      v-slot="{ errors }"
                      name="recriptDateTo"
                      rules="max:100"
                    >
                      <v-menu
                        v-model="ReceptionDateTo"
                        :close-on-content-click="false"
                        location="bottom start"
                        :offset="[0, -40]"
                        transition="scale-transition"
                      >
                        <template #activator="{ props }">
                          <v-text-field
                            v-bind="props"
                            :model-value="searchConditionReceptionDateToDisplay"
                            :label="wordList.lbl_recript_date_to"
                            prepend-icon="mdi-calendar"
                            readonly
                            variant="outlined"
                            density="compact"
                            clearable
                            :error-messages="errors"
                            bg-color="#fff"
                            @click:clear="clearReceptionDateTo"
                          ></v-text-field>
                        </template>
                        <v-locale-provider
                          locale="ja"
                          :messages="{ ja: vuetifyJa }"
                        >
                          <v-date-picker
                            v-datepicker-scroll
                            v-model="searchConditionReceptionDateTo"
                            hide-header
                            show-adjacent-months
                            view-mode="month"
                            @update:model-value="onReceptionDateToSelected"
                          ></v-date-picker>
                        </v-locale-provider>
                      </v-menu>
                    </Field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col cols="11" sm="4" class="py-0">
                    <Field
                      v-slot="{ errors }"
                      name="deliveryDateFrom"
                      rules="max:100"
                    >
                      <v-menu
                        v-model="DeliveryDateFrom"
                        :close-on-content-click="false"
                        location="bottom start"
                        :offset="[0, -40]"
                        transition="scale-transition"
                      >
                        <template #activator="{ props }">
                          <v-text-field
                            v-bind="props"
                            :model-value="searchConditionDeliveryDateFromDisplay"
                            :label="wordList.lbl_delivery_date_from"
                            prepend-icon="mdi-calendar"
                            readonly
                            variant="outlined"
                            density="compact"
                            clearable
                            :error-messages="errors"
                            bg-color="#fff"
                            hide-details
                            @click:clear="clearDeliveryDateFrom"
                          ></v-text-field>
                        </template>
                        <v-locale-provider
                          locale="ja"
                          :messages="{ ja: vuetifyJa }"
                        >
                          <v-date-picker
                            v-datepicker-scroll
                            v-model="searchConditionDeliveryDateFrom"
                            hide-header
                            show-adjacent-months
                            view-mode="month"
                            @update:model-value="onDeliveryDateFromSelected"
                          ></v-date-picker>
                        </v-locale-provider>
                      </v-menu>
                    </Field>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-center"
                    ><span>〜</span></v-col
                  >
                  <v-col cols="11" sm="4" class="py-0">
                    <Field
                      v-slot="{ errors }"
                      name="deliveryDateTo"
                      rules="max:100"
                    >
                      <v-menu
                        v-model="DeliveryDateTo"
                        :close-on-content-click="false"
                        location="bottom start"
                        :offset="[0, -40]"
                        transition="scale-transition"
                      >
                        <template #activator="{ props }">
                          <v-text-field
                            v-bind="props"
                            :model-value="searchConditionDeliveryDateToDisplay"
                            :label="wordList.lbl_delivery_date_to"
                            prepend-icon="mdi-calendar"
                            readonly
                            variant="outlined"
                            density="compact"
                            clearable
                            :error-messages="errors"
                            bg-color="#fff"
                            @click:clear="clearDeliveryDateTo"
                          ></v-text-field>
                        </template>
                        <v-locale-provider
                          locale="ja"
                          :messages="{ ja: vuetifyJa }"
                        >
                          <v-date-picker
                            v-datepicker-scroll
                            v-model="searchConditionDeliveryDateTo"
                            hide-header
                            show-adjacent-months
                            view-mode="month"
                            @update:model-value="DeliveryDateTo = false"
                          ></v-date-picker>
                        </v-locale-provider>
                      </v-menu>
                    </Field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0 pb-9">
                <v-card flat>
                  <v-card-title class="px-0 pt-0 pb-2 text-subtitle-2">
                    {{ wordList.lbl_status }}
                  </v-card-title>
                  <v-card-text class="px-0 py-0">
                    <v-row>
                      <div
                        v-for="item in deliveryStatusName"
                        :key="item.id"
                        class="pr-3 pl-2 d-flex"
                      >
                        <v-checkbox
                          v-model="statusSelectedItem"
                          :value="item.id"
                          :label="item.name"
                          hide-details
                        ></v-checkbox>
                      </div>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              variant="flat"
              color="primary"
              class="px-16 my-3"
              :disabled="invalid"
              @click="onClickSearch(false)"
              ><v-icon>mdi-magnify</v-icon>{{ wordList.lbl_search }}</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </Form>
    </v-dialog>
    <!-- } スマホ検索ダイアログ -->
  </v-container>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useDisplay } from "vuetify";
import { ja as vuetifyJa } from "vuetify/locale";

// ------ Vee-Validate ------
import { Form, Field, defineRule, configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import { required, max, min, numeric, regex, length } from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";

// ------ Composables ------
import { useDeliveryMoveUiState } from "./composables/useDeliveryMoveUiState";
import { useDeliveryMoveSearchForm } from "./composables/useDeliveryMoveSearchForm";
import { useDeliveryMoveTable } from "./composables/useDeliveryMoveTable";
import {
  useDeliveryMoveDeliveryTimeState,
  useDeliveryMoveDeliveryTime,
} from "./composables/useDeliveryMoveDeliveryTime";
import {
  useDeliveryMoveInitState,
  useDeliveryMoveInit,
} from "./composables/useDeliveryMoveInit";
import { useDeliveryMoveFilterOptions } from "./composables/useDeliveryMoveFilterOptions";
import { useDeliveryMoveAddress } from "./composables/useDeliveryMoveAddress";
import { useDeliveryMoveActions } from "./composables/useDeliveryMoveActions";
import { useDeliveryMoveEditForm } from "./composables/useDeliveryMoveEditForm";
import { useDeliveryMoveDownload } from "./composables/useDeliveryMoveDownload";
import { DELIVERY_MOVE_LIST_FILE_NAME } from "./constants";

// ------ Local Components ------
import ImportantChip from "@/components/ImportantChip.vue";
import AlertDialog from "@/components/AlertDialog.vue";

// ------ Utilities / Common ------
import draggable from "vuedraggable";
import { DeliveryRequest } from "@/common/constant";

// ============================
// Vee-Validate rules / locale
// ============================
defineRule("required", required);
defineRule("max", max);
defineRule("min", min);
defineRule("numeric", numeric);
defineRule("regex", regex);
defineRule("length", length);
configure({
  generateMessage: localize({
    ja,
  }),
});
localize("ja");

// ============================
// state
// ============================
// Vuetify breakpoint
const { xs } = useDisplay();
const isXs = computed(() => xs.value);

// コンポーネント名
const thisFileName = DELIVERY_MOVE_LIST_FILE_NAME;

// -------------------------------
// 画面UI状態
// -------------------------------
const {
  errdialog,
  errMessage,
  editPage,
  confirmPage,
  panel,
  processFlag,
  confirmDeleteDialog,
  overlay,
  downloadingDialog,
  displayListSearchDialog,
  onClickListSearch,
  openListPage,
  openConfirmPage,
} = useDeliveryMoveUiState();

// -------------------------------
// 一覧テーブル定義
// -------------------------------
const {
  defaultTableHeaders,
  tableHeaders,
  initTableHeaders,
  filteredTableHeaders,
  deliveryStatusName,
  pickupDeliveryStatusName,
  pickupDeliveryTypeName,
  listLoading,
  listOptions,
  listDataArray,
  listDataTotalCount,
  pageCount,
  selectListCheckbox,
  filteredSelectListCheckbox,
  tableHeadersSetting,
  displayListSettingDialog,
  onClickListSetting,
  onClickListSettingCancel,
  onClickListSettingReset,
  onClickListSettingOk,
} = useDeliveryMoveTable();

// -------------------------------
// 検索フォーム State
// -------------------------------
const {
  formatDateForDisplay,
  searchConditionReceptionNo,
  searchConditionReceptionDateFrom,
  searchConditionReceptionDateTo,
  searchConditionDeliveryDateFrom,
  searchConditionDeliveryDateTo,
  searchConditionReceptionDateFromDisplay,
  searchConditionReceptionDateToDisplay,
  searchConditionDeliveryDateFromDisplay,
  searchConditionDeliveryDateToDisplay,
  ReceptionDateFrom,
  ReceptionDateTo,
  DeliveryDateFrom,
  DeliveryDateTo,
  onReceptionDateFromSelected,
  onReceptionDateToSelected,
  onDeliveryDateFromSelected,
  onDeliveryDateToSelected,
  clearReceptionDateFrom,
  clearReceptionDateTo,
  clearDeliveryDateFrom,
  clearDeliveryDateTo,
  statusSelectedItem,
  deliveryTypeValues,
} = useDeliveryMoveSearchForm();

// -------------------------------
// 初期化・共有 State
// -------------------------------
const {
  deliveryTypeItems,
  isOperatorGroupShop,
  shopDisabledFlag,
  shopListInput,
  shopToListInput,
  shopFromListInput,
  shopListItems,
  shopToListItems,
  shopFromListItems,
  bufShopListItems,
  shopFromAllCheckFlag,
  shopToAllCheckFlag,
  shopSelectValues_from,
  shopSelectValues_to,
  searchConditionChainCode,
  searchShopSelectValuesFrom,
  searchShopSelectValuesTo,
  shopSelectValuesFrom,
  shopSelectValuesTo,
  shopData,
  shopData_from_address,
  shopData_from_address1,
  shopData_to_address,
  shopData_to_address1,
  authType,
  isMounted,
  chainViewFlag,
  chainListItems,
  bufChainListItems,
  chainSelectValues,
  chainAllCheckFlag,
  areaSelectValues,
  unitItems,
  paymentRequiredFlg,
  paymentList,
  chainPaymentMethodSelectValues,
  editDeliveryRequest,
  paymentMethodItems,
  dummy_payment_amount,
  deliveryNotesBefore,
  messageDeliveryNotes,
  isDisabled,
  isDisabledChangeFromTo,
  wordList,
  displayPagingRange,
} = useDeliveryMoveInitState();

// -------------------------------
// 便・時間帯 State
// -------------------------------
const {
  listDeliveryArea,
  deliveryAreaName,
  acceptableEndTime,
  deliveryStartHourItem,
  deliveryStartHourValues,
  deliveryStartMinitItem,
  deliveryStartMinitValues,
  befor_data,
  irregularDeliveryStartTime,
  irregularDeliveryEndTime,
  deliveryId_0_Flg,
  deliveryStartTime,
  deliveryEndTime,
  overDeliveryEndTime,
  doubleDeliOriconCount,
  isDoubleDeli,
  pre_double_deli_oricon_flg,
  charterDeliOriconCount,
  isCharterDeli,
  pre_charter_deli_oricon_flg,
  deliveryAvailabilityHeader,
  deliveryAvailabilityData,
  disp_deliveryAvailabilityData,
  display_delivery_time,
  deliverySelectDayBox,
  deliverySelectBox,
} = useDeliveryMoveDeliveryTimeState();

// -------------------------------
// フィルタ連動
// -------------------------------
const {
  onchangeChainAllCheck,
  onChangeChain,
  onChangeShopAllCheck,
  onChangeShop,
} = useDeliveryMoveFilterOptions({
  chainListItems,
  bufChainListItems,
  chainSelectValues,
  chainAllCheckFlag,
  searchConditionChainCode,
  shopListItems,
  bufShopListItems,
  shopSelectValuesFrom,
  shopSelectValuesTo,
  searchShopSelectValuesFrom,
  searchShopSelectValuesTo,
  shopFromAllCheckFlag,
  shopToAllCheckFlag,
  shopDisabledFlag,
  shopListInput,
  listDataArray,
  listOptions,
  listDataTotalCount,
  errdialog,
  errMessage,
});

// -------------------------------
// 便・時間帯ロジック
// -------------------------------
const {
  onClickListDeliveryArea,
  getAreaList,
  setDeliveryStartTime,
  setDeliveryEndTime,
  onChangeDeliveryStartHour,
  onChangeDeliveryStartMinit,
  onDeliveryAvailabilityClick,
  formatDate,
} = useDeliveryMoveDeliveryTime({
  listDeliveryArea,
  deliveryAreaName,
  acceptableEndTime,
  deliveryStartHourItem,
  deliveryStartHourValues,
  deliveryStartMinitItem,
  deliveryStartMinitValues,
  befor_data,
  irregularDeliveryStartTime,
  irregularDeliveryEndTime,
  deliveryId_0_Flg,
  deliveryStartTime,
  deliveryEndTime,
  overDeliveryEndTime,
  deliveryAvailabilityHeader,
  deliveryAvailabilityData,
  disp_deliveryAvailabilityData,
  display_delivery_time,
  deliverySelectDayBox,
  deliverySelectBox,
  editDeliveryRequest,
  shopSelectValues_from,
  errdialog,
  errMessage,
});

// -------------------------------
// 住所（配達元・配達先）ロジック
// -------------------------------
const {
  onChangeShopFrom,
  onChangeShopTo,
  onClickShopChangeBtn,
} = useDeliveryMoveAddress({
  shopSelectValues_from,
  shopSelectValues_to,
  shopData_from_address,
  shopData_from_address1,
  shopData_to_address,
  shopData_to_address1,
  shopData,
  shopFromListItems,
  shopToListItems,
  shopFromListInput,
  shopToListInput,
  editDeliveryRequest,
  isDisabledChangeFromTo,
  deliveryAreaName,
  display_delivery_time,
  deliveryAvailabilityHeader,
  deliveryAvailabilityData,
  disp_deliveryAvailabilityData,
  listDeliveryArea,
  deliveryId_0_Flg,
  deliveryStartHourItem,
  deliveryStartHourValues,
  deliveryStartMinitValues,
  doubleDeliOriconCount,
  charterDeliOriconCount,
  errdialog,
  errMessage,
  getAreaList,
});

// -------------------------------
// 初期化ロジック
// -------------------------------
const {
  onClickSearch,
  initOnMounted,
} = useDeliveryMoveInit({
  errdialog,
  errMessage,
  overlay,
  displayListSearchDialog,
  authType,
  isMounted,
  chainViewFlag,
  chainListItems,
  bufChainListItems,
  chainSelectValues,
  chainAllCheckFlag,
  areaSelectValues,
  unitItems,
  paymentRequiredFlg,
  paymentList,
  paymentMethodItems,
  editDeliveryRequest,
  shopListInput,
  shopListItems,
  shopFromListItems,
  shopToListItems,
  bufShopListItems,
  shopFromAllCheckFlag,
  shopToAllCheckFlag,
  shopDisabledFlag,
  isOperatorGroupShop,
  shopSelectValuesFrom,
  shopSelectValuesTo,
  searchConditionChainCode,
  searchShopSelectValuesFrom,
  searchShopSelectValuesTo,
  searchConditionReceptionNo,
  searchConditionReceptionDateFrom,
  searchConditionReceptionDateTo,
  searchConditionDeliveryDateFrom,
  searchConditionDeliveryDateTo,
  deliveryTypeValues,
  statusSelectedItem,
  listOptions,
  listDataArray,
  listDataTotalCount,
  listLoading,
  selectListCheckbox,
  displayPagingRange,
  wordList,
  formatDateForDisplay,
  pickupDeliveryStatusName,
  pickupDeliveryTypeName,
  initTableHeaders,
});

// -------------------------------
// マウント時処理
// -------------------------------
onMounted(async (): Promise<void> => {
  await initOnMounted();
});

// -------------------------------
// 一覧行アクション
// -------------------------------
const {
  onClickEdit,
  onClickCheckDelete,
  onClickCheckDeleteComplete,
  onClickDelete,
  onClickConfirmDeleteOk,
  onClickUpdateCancel,
  onChangePaymentMethod,
} = useDeliveryMoveActions({
  errdialog,
  errMessage,
  editPage,
  confirmPage,
  processFlag,
  confirmDeleteDialog,
  overlay,
  editDeliveryRequest,
  shopSelectValues_from,
  shopSelectValues_to,
  shopData_from_address,
  shopData_to_address,
  shopFromListItems,
  shopFromListInput,
  isDisabled,
  isDisabledChangeFromTo,
  dummy_payment_amount,
  deliveryNotesBefore,
  messageDeliveryNotes,
  deliveryAvailabilityData,
  deliveryAvailabilityHeader,
  disp_deliveryAvailabilityData,
  deliveryAreaName,
  display_delivery_time,
  deliveryId_0_Flg,
  deliveryStartTime,
  deliveryEndTime,
  deliveryStartHourItem,
  deliveryStartHourValues,
  deliveryStartMinitItem,
  deliveryStartMinitValues,
  befor_data,
  irregularDeliveryStartTime,
  irregularDeliveryEndTime,
  acceptableEndTime,
  listDeliveryArea,
  isDoubleDeli,
  isCharterDeli,
  pre_double_deli_oricon_flg,
  pre_charter_deli_oricon_flg,
  selectListCheckbox,
  filteredSelectListCheckbox,
  paymentList,
  paymentRequiredFlg,
  chainViewFlag,
  onClickSearch,
  openListPage,
  openConfirmPage,
  onChangeShopFrom,
  getAreaList,
  onClickListDeliveryArea,
  setDeliveryStartTime,
  setDeliveryEndTime,
});

// -------------------------------
// 編集フォームロジック
// -------------------------------
const {
  commmaMoney,
  onFocus,
  onBlur,
  onClickUpdate,
  onClickConfirmUpdateCancel,
  onClickConfirmUpdateOk,
  doubleDeliCheckLabel,
  charterDeliChkLabel,
} = useDeliveryMoveEditForm({
  errdialog,
  errMessage,
  editPage,
  confirmPage,
  processFlag,
  overlay,
  editDeliveryRequest,
  shopSelectValues_from,
  shopSelectValues_to,
  dummy_payment_amount,
  deliveryNotesBefore,
  messageDeliveryNotes,
  deliveryId_0_Flg,
  irregularDeliveryStartTime,
  irregularDeliveryEndTime,
  overDeliveryEndTime,
  acceptableEndTime,
  doubleDeliOriconCount,
  charterDeliOriconCount,
  isDoubleDeli,
  isCharterDeli,
  pre_double_deli_oricon_flg,
  pre_charter_deli_oricon_flg,
  wordList,
  onClickSearch,
  openListPage,
});

// -------------------------------
// CSVダウンロード
// -------------------------------
const { onClickDownload } = useDeliveryMoveDownload({
  errdialog,
  errMessage,
  overlay,
  downloadingDialog,
  listDataTotalCount,
  searchConditionReceptionNo,
  searchConditionReceptionDateFrom,
  searchConditionReceptionDateTo,
  searchConditionDeliveryDateFrom,
  searchConditionDeliveryDateTo,
  deliveryTypeValues,
  areaSelectValues,
  statusSelectedItem,
  searchConditionChainCode,
  searchShopSelectValuesFrom,
  searchShopSelectValuesTo,
  formatDateForDisplay,
});
</script>
<style scoped>
/* disabled状態のテキストフィールドを黒字で表示 */
.disabled-text-field :deep(.v-field__input) {
  color: rgba(0, 0, 0, 0.87) !important;
  opacity: 1 !important;
}
.disabled-text-field :deep(.v-field--disabled) {
  opacity: 1 !important;
}
/* 一覧設定ダイアログ: v-radio-groupのデフォルトflex-directionを上書きして横並びにする */
:deep(.v-radio-group > .v-input__control) {
  flex-direction: row;
}
/* 配達希望時間選択の行折り返し防止 */
.delivery-time-row {
  flex-wrap: nowrap;
}
.delivery-time-select {
  min-width: 80px;
  width: 80px;
  flex: 0 0 80px;
}
.delivery-time-select :deep(.v-input__details) {
  display: none;
}
</style>
